<template>
  <div class="travel-recommend-wrapper">
    <MultiJumpContainer
      v-for="(item, index) in list"
      :key="index"
      :biTag="item.title"
      :jumpInfo="{
        jumpUrl: getJumpUrl(item),
        appid: item.appid,
        username: item.username,
        path: item.path,
      }"
    >
      <div class="row-card">
        <div class="row-card-left">
          <img class="logo" :src="item.logo" alt="" />
          <div class="info">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
          </div>
        </div>
        <div class="row-card-right">
          <FitIcon class="icon" namespace="wphk-ui" icon="arrow-right"></FitIcon>
        </div>
      </div>
    </MultiJumpContainer>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount } from 'vue';
import { ModuleName } from '@/types/module-type';
import { MultiJumpContainer } from '@tencent/wphk-components-multi-jump-container';
import { FitIcon } from '@tencent/wphk-ui';
import { useConfigStore } from '@/store';
import { getJumpUrl } from '@/utils';

const props = defineProps<{ moduleName: ModuleName }>();
const emit = defineEmits(['onHideModule']);

// store
const { getConfig } = useConfigStore();

const list = ref<any[]>([]);

onBeforeMount(async () => {
  const { list: listVal } = await getConfig(props.moduleName);
  list.value = listVal;
  if (!list.value.length) {
    emit('onHideModule', props.moduleName);
  }
});
</script>

<style lang="less">
@import (reference) '~@/less/main';
.travel-recommend-wrapper {
  .row-card {
    width: 100%;
    box-sizing: border-box;
    padding: 44 / @rem 32 / @rem;
    background-color: #fff;
    border-radius: 16 / @rem;
    margin-bottom: 16 / @rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .row-card-left {
      display: flex;
      align-items: center;
      .logo {
        width: 65 / @rem;
        margin-right: 16 / @rem;
      }
      .info {
        .title {
          .font-28-medium(#000000e6);
        }
        .desc {
          .font-24-regular(#00000080);
        }
      }
    }
    .row-card-right {
      .icon {
        font-size: 34 / @rem;
      }
    }
  }
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
